module.exports = __webpack_public_path__ + "img/lens-174-minus-06.7835fb6c.png";